import type { HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { Link } from '@/routing'
import { Text } from '@/shared/ui'
import style from './comment-card.module.scss'

interface CommentProps extends HTMLProps<HTMLDivElement> {
  name?: string
  text?: string | null
  src?: string
  link: string | null
}

export const CommentCard = (props: CommentProps) => {
  const { className, name, text, src, link } = props
  const translate = useTranslations()

  return (
    <div className={clsx(className, 'item', style.card)}>
      {name && (
        <Text className={style.author} tagName="p" type="d">
          {name}
        </Text>
      )}
      {text && (
        <Text className={style.comment} tagName="p" type="t2">
          {text}
          &nbsp;
        </Text>
      )}
      {link && (
        <Link href={link}>
          <Text className={style.experts} tagName="p" type="t2">
            {translate('linkReadCompletely')}
          </Text>
        </Link>
      )}
      {src && <Image className={style.photo} src={src} alt={'advertisement'} width={72} height={72} />}
    </div>
  )
}
